module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.fa27723.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/waste-glass-bottle2/font/glyphicons-halflings-regular.woff
// module id = SGW8
// module chunks = 0